window.addEventListener('load', function() {

jQuery(document).ready(function () {


jQuery(document).on('click','.country-dropdown-link',function(e){
  e.preventDefault();
 jQuery('.header-langbox').toggleClass('active');
});


  // The filter boxes' open/close now lives in sections/main-collection-product-grid.liquid,
  // so it works before the page has finished loading every image.


 
    var HomeBanner = new Swiper(".merit-slider-outer", {
        loop: true,
        autoplay: {
            delay: 10000,
        },
        spaceBetween: 0,
        slidesPerView: 1,
        pagination: {
            el: ".banner-pagination",
            clickable: true,
        },
    });


    var swiper3 = new Swiper(".team-profile-slider", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".team-slider-next",
            prevEl: ".team-slider-prev",
        },
        slidesPerView: 3,
      centeredSlides: false,
        loop: true,
        spaceBetween: 15,
        breakpoints: {
            320: {
                slidesPerView: 1.1,
            },
            480: {
                slidesPerView: 1.1,
            },
            768: {
                slidesPerView: 2,
            },
            992: {
                slidesPerView: 3,
            },
        },
    });
    var swiper4 = new Swiper(".good-hands-slider", {
        spaceBetween: 10,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        // pagination: {
        //     el: '.swiper-pagination',
        //     type: 'bullets',
        //     clickable: true
        // },
        slidesPerView: 3.2,
        loop: false,
        spaceBetween: 15,
        breakpoints: {
            320: {
                slidesPerView: 1.1,
            },
            480: {
                slidesPerView: 1.1,
            },
            768: {
                slidesPerView: 2.1,
            },
            992: {
                slidesPerView: 3.1,
            },
        },
    });


    var swiper5 = new Swiper(".featured-blocks-slider", {
  slidesPerView: 'auto',
  // Five cards nearly fill a desktop screen, so as a plain row there was only
  // about one card of movement and it felt stuck. Looping lets it carry on
  // round for as long as you drag.
  loop: true,
  // Same as the product rows: grabbable, and the click at the end of a drag is
  // swallowed rather than opening the card underneath.
  grabCursor: true,
  simulateTouch: true,
  preventClicks: true,
  preventClicksPropagation: true,
  threshold: 5,
  // freeMode is off: Swiper cannot keep the looped copies in order alongside
  // it, which left the row with barely any travel.
  freeMode: false,
  speed: 500, // slower = smoother
  spaceBetween: 10,
  navigation: {
    nextEl: ".block-slider-next",
    prevEl: ".block-slider-prev",
  },
  on: {
    init: function () {
      document.querySelectorAll('.featured-blocks-slider .swiper-slide').forEach(slide => {
        slide.style.width = '365px';
      });
    }
  }
});




//     $(".header-top-bar-inner").slick({
//         // normal options...
//         infinite: true,
//         slidesToShow: 4.5,
//         //variableWidth: true,
//         autoplay: true,
//         arrows: false,
//         dots: false,
//         infinite: true,
//       cssEase: 'linear',
//       speed: 9000,
// autoplay: true,
//       autoplaySpeed: 0,
//         // the magic
//         responsive: [
//             {
//                 breakpoint: 1024,
//                 settings: {
//                     slidesToShow: 3,
//                       variableWidth: true,


//                 },
//             },
//             {
//                 breakpoint: 900,
//                 settings: {
//                     slidesToShow: 3,
//                 },
//             },
//             {
//                 breakpoint: 500,
//                 settings: {
//                     slidesToShow: 2,
//                 },
//             },
//         ],
//     });


    if (window.matchMedia("(max-width: 1150px)").matches) {


    }
    // The client logos now scroll continuously via CSS at every screen size
    // (see custom-client-logos.liquid), so the old mobile Slick carousel is
    // skipped. Running both left the list cloned and hugely mis-sized.
    if (window.matchMedia("(max-width:767px)").matches) {
        $(".footer-logo-list-section ul").not(".logo-marquee__track ul").slick({
            infinite: true,
            slidesToShow: 3,
            autoplay: true,
            arrows: false,
            dots: false,
        });
    }


    $(document).find(".slick-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 3,
    });


    $(document).on("click", ".joinnow-btn", function (e) {
        e.preventDefault();
        var form = $(this).closest('form'),
                email = $(form).find('[type="email"]').val();
        const options = {
            method: "POST",
            headers: {
                accept: "application/json",
                "content-type": "application/json",
            },
            body: JSON.stringify({
                profiles: [
                    {email: email}
                ],
            }),
        };


        fetch(
                "https://a.klaviyo.com/api/v2/list/VmEnvL/subscribe?api_key=pk_092fe606b269dd8df3460025b8f9c4ed18",
                options
                )
                .then((response) => response.json())
                .then((response) => console.log(response))
                .catch((err) => console.error(err));
    });


  $('.blog-content-left span[style]').removeAttr('style');




});


document.addEventListener('DOMContentLoaded', () => {
    const marqueeInner = document.querySelector('.marquee-inner');
    const items = Array.from(marqueeInner.children);
    const containerWidth = document.querySelector('.marquee-container').offsetWidth;


    let totalWidth = 0;
    items.forEach(item => {
        totalWidth += item.offsetWidth + parseInt(window.getComputedStyle(item).marginRight);
    });


    // Clone items until the total width exceeds container width * 2 for seamless scrolling
    while (totalWidth < containerWidth * 2) {
        items.forEach(item => {
            const clone = item.cloneNode(true);
            marqueeInner.appendChild(clone);
            totalWidth += item.offsetWidth + parseInt(window.getComputedStyle(item).marginRight);
        });
    }


    // Set dynamic animation duration
    marqueeInner.style.animationDuration = `${totalWidth / 100}s`;
});


jQuery(document).ready(function($) {
  // Hide all artist sections except the first one
  $('.moreartist-section').hide().first().show();


  $(document).on('click', '.moreartist-section .magnum-green-btn', function(e) {
    e.preventDefault();


    // Hide the button that was clicked
    $(this).closest('.sponsored-artist-btn-box').hide();


    // Find and show the next hidden .moreartist-section
    const $nextSection = $('.moreartist-section:hidden').first();


    if ($nextSection.length > 0) {
      $nextSection.slideDown();


      // Immediately hide its button too
      $nextSection.find('.sponsored-artist-btn-box').hide();
    }
  });


jQuery(document).on('click','a.notifybtn.btn.theme-btn',function(e){
  jQuery('.klaviyo-bis-trigger').trigger('click');
});




 
});


// document.addEventListener('DOMContentLoaded', function () {
//     const triggerButton = document.querySelector('a.notifybtn.btn.theme-btn');
//     const targetButton = document.querySelector('.lkbtn');


//     triggerButton.addEventListener('click', function () {
//       targetButton.click(); // Trigger the target button
//     });
//   });


  document.addEventListener('DOMContentLoaded', function () {
    const triggerButton = document.querySelector('a.notifybtn.btn.theme-btn');


    triggerButton.addEventListener('click', function () {
      // Wait for the target button to appear
      const interval = setInterval(function () {
        const targetButton = document.querySelector('.lkbtn');
        if (targetButton) {
          targetButton.click(); // Trigger it
          clearInterval(interval); // Stop checking
        }
      }, 500); // Check every 300ms
    });
  });



});